import React, { useCallback, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Button } from '@spark/ui-components/components/Button';
import TanStackTable from '@spark/ui-components/components/TanStackTable/TanStackTable';
import { useHistory } from 'react-router-dom';
import { usePedidosTab } from '../../../hooks/usePedidosTab';
import { getPedidosColumnsDepot } from './tanStackColumnsDepot';
import PedidoFormModalDepot from './PedidoFormModalDepot';

const PedidosTab = ({ depotId }) => {
  const history = useHistory();
  const { pedidos, loading, loadPedidos } = usePedidosTab(depotId);
  const [showModal, setShowModal] = useState(false);
  const [duplicatePedidoId, setDuplicatePedidoId] = useState(null);
  const handleRowClick = useCallback((row) => {
    const search = depotId ? `?depotId=${encodeURIComponent(depotId)}` : '';
    history.push({
      pathname: `/pages/pedidos/detalhes/${row.id}`,
      search
    });
  }, [history, depotId]);

  return (
    <>
      <Row className="mb-3">
        <Col md={12} className="d-flex justify-content-end">
          <Button variant="primary" onClick={() => {
            setDuplicatePedidoId(null);
            setShowModal(true);
          }}>
            Novo pedido
          </Button>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <TanStackTable
            columns={getPedidosColumnsDepot((pedido) => {
              if (!pedido?.id) {
                return;
              }
              setDuplicatePedidoId(pedido.id);
              setShowModal(true);
            })}
            data={pedidos}
            loading={!!loading}
            isSortable={true}
            withPagination={false}
            enableRowColors={true}
            onRowClick={handleRowClick}
          />
        </Col>
      </Row>

      <PedidoFormModalDepot
        show={showModal}
        onClose={() => {
          setShowModal(false);
          setDuplicatePedidoId(null);
        }}
        depotId={depotId}
        onCreated={loadPedidos}
        duplicatePedidoId={duplicatePedidoId}
      />
    </>
  );
};

export default PedidosTab;
